import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "@/components/ui/sonner";
import { WishlistProvider } from "@/context/WishlistContext";
import { ProductsProvider } from "@/context/ProductsContext";
import { AuthProvider } from "@/context/AuthContext";
import LenisProvider from "@/components/LenisProvider";
import IntroOverlay from "@/components/IntroOverlay";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import StickyWhatsApp from "@/components/StickyWhatsApp";
import BackToTop from "@/components/BackToTop";
import ScrollToTop from "@/components/ScrollToTop";
import ProtectedRoute from "@/components/ProtectedRoute";
import Home from "@/pages/Home";
import Collections from "@/pages/Collections";
import Shop from "@/pages/Shop";
import About from "@/pages/About";
import CustomOrders from "@/pages/CustomOrders";
import CorporateGifting from "@/pages/CorporateGifting";
import Blog from "@/pages/Blog";
import Contact from "@/pages/Contact";
import Wishlist from "@/pages/Wishlist";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";

function Chrome({ children }) {
  const { pathname } = useLocation();
  const isAdmin = pathname.startsWith("/admin");
  return (
    <>
      {!isAdmin && <IntroOverlay />}
      <ScrollToTop />
      {!isAdmin && <Navbar />}
      <main>{children}</main>
      {!isAdmin && <Footer />}
      {!isAdmin && <StickyWhatsApp />}
      {!isAdmin && <BackToTop />}
    </>
  );
}

function App() {
  return (
    <div className="App">
      <HelmetProvider>
        <ProductsProvider>
          <WishlistProvider>
            <AuthProvider>
              <BrowserRouter>
                <LenisProvider>
                  <Chrome>
                    <Routes>
                      <Route path="/" element={<Home />} />
                      <Route path="/collections" element={<Collections />} />
                      <Route path="/shop" element={<Shop />} />
                      <Route path="/about" element={<About />} />
                      <Route path="/custom-orders" element={<CustomOrders />} />
                      <Route path="/corporate-gifting" element={<CorporateGifting />} />
                      <Route path="/blog" element={<Blog />} />
                      <Route path="/contact" element={<Contact />} />
                      <Route path="/wishlist" element={<Wishlist />} />
                      <Route path="/admin/login" element={<AdminLogin />} />
                      <Route path="/admin" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
                    </Routes>
                  </Chrome>
                  <Toaster position="bottom-center" theme="light" />
                </LenisProvider>
              </BrowserRouter>
            </AuthProvider>
          </WishlistProvider>
        </ProductsProvider>
      </HelmetProvider>
    </div>
  );
}

export default App;
